<template lang="pug">
  .reason-list-wrapper
    h2 motivos padrão

    .filters(v-if="!showCreateEdit")
      .total
        span total de motivos padrão: {{ totalReasons }}
        PSelect(
          v-model="mode"
          name="mode"
          labelItem="name"
          :allowEmpty="false"
          title="mostrar"
          @change="changeMode"
          :disabled="algoCarregando"
        )
      .buttons
        PButton(color="primary" size="md" @click="genReport" :disabled="algoCarregando" :loading="carregandoRelatorio") gerar relatório
        PButton(
          color="warning"
          size="md"
          @click="createReason"
          :disabled="algoCarregando"
          v-if="$hasPermission({module: 'reason', action: 'post'})"
        )
          | criar novo motivo padrão

    .add-edit-reason(v-else)
      Validate(v-model="saveEditInfo.description" :minLength="4")
        PTextField(name="description" label="nome do motivo" :disabled="carregandoSalvar")

      PTextField(v-model="saveEditInfo.code" label="código" type="text" :disabled="carregandoSalvar")

      .tipo
        PSelect(
          name="kind"
          v-model="saveEditInfo.options"
          title="tipo"
          labelItem="name"
          :allowEmpty="false"
          :disabled="carregandoSalvar"
        )

      .left-checkbox(v-if="saveEditInfo.options.selected.id === 'justify'")
        PCheckbox(
          label="Obrigatório preencher informações do atestado (CID, nome do médico, CRM, entre outros)"
          v-model="saveEditInfo.justifyInfoRequired"
          :disabled="carregandoSalvar"
        )

      .middle-checkbox(v-if="saveEditInfo.options.selected.id === 'justify'")
        PCheckbox(
          label="Obrigatório anexar arquivo"
          v-model="saveEditInfo.fileRequired"
          :disabled="carregandoSalvar"
        )

      //Somente para Atento, por enquanto
      .right-checkbox(v-if="saveEditInfo.options.selected.id === 'justify' && idDaCompMan === '5dc02085dc99a6000ddf2bf2'")
        PCheckbox(
          label="Motivo incide no cálculo de absenteísmo"
          v-model="saveEditInfo.justifyAffectsAbsence"
          :disabled="carregandoSalvar"
        )

      .button
        PButton(size="md" color="success" @click="save" :loading="carregandoSalvar") salvar
        PButton(size="md" color="danger" @click="resetNewOrEditedReason" :disabled="carregandoSalvar") cancelar

    SmartTable.table(name="employer-list" v-bind="table", v-model="tableData" ref="table")
      template(v-slot:default="slotProps")
        TableRow(v-bind="slotProps")

          template(v-slot:description="{ columnValue, rowItem, index }")
            span.no-wrap(:title="columnValue") {{ columnValue }}

          template(v-slot:kind="{ columnValue, rowItem, index }")
            span.no-wrap(:title="kindTranslator(columnValue)") {{ kindTranslator(columnValue) }}

          template(v-slot:justifyInfoRequired="{ columnValue, rowItem, index }")
            template(v-if="rowItem.kind === 'justify'")
              | {{ columnValue ? 'sim': 'não' }}

      template(v-slot:detailsBox="{item}")
        .details
          DBLabel(title="nome:" :body="item.description")
          DBLabel(title="código:" :body="item.code")
          DBLabel(title="tipo:" :body="kindTranslator(item.kind)")
          template(v-if="item.kind === 'justify'")
            DBLabel(title="dados do atestado obrigatórios:" :body="item.justifyInfoRequired ? 'sim': 'não'")
          template(v-if="item.kind === 'justify'")
            DBLabel(title="anexar arquivo obrigatório:" :body="item.fileRequired ? 'sim': 'não'")

          //Somente para Atento, por enquanto
          template(v-if="item.kind === 'justify' && idDaCompMan === '5dc02085dc99a6000ddf2bf2'")
            DBLabel(title="justificativa incide no absenteísmo:" :body="item.justifyAffectsAbsence ? 'sim': 'não'")

          .actions-buttons
            PButton(
              v-if="mode.selected.id === 'ativados'"
              color="warning"
              size="md"
              title="desativar"
              :disabled="carregandoExcluir || carregandoSalvar"
              :loading="carregandoAtivacaoDesativacao"
              @click="ativarOuDesativarMotivo(item.id)"
            )
              .icon-bv-icones-nao
            PButton(
              v-if="mode.selected.id === 'desativados'"
              color="success"
              size="md"
              title="ativar"
              :disabled="carregandoExcluir || carregandoSalvar"
              :loading="carregandoAtivacaoDesativacao"
              @click="ativarOuDesativarMotivo(item.id)"
            )
              .icon-ptt-icons-check
            PButton(
              color="info"
              size="md"
              title="editar"
              :disabled="carregandoExcluir || carregandoSalvar || carregandoAtivacaoDesativacao"
              @click="editReason"
            )
              .icon-ptt-icons-lapis
            //- PConfirmButton(
            //-   text="Excluir este motivo padrão?"
            //-   color="danger"
            //-   size="md"
            //-   title="excluir"
            //-   :loading="carregandoExcluir"
            //-   :disabled="carregandoSalvar || carregandoAtivacaoDesativacao"
            //-   @click="deleteReason(item.id)"
            //- )
            //-   .icon-ptt-icons-excluir
</template>

<script>
import { useValidationsMixin } from 'src/common/validations'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

function defaultSaveEditInfo () {
  return {
    description: '',
    code: null,
    options: {
      selected: {name: 'Eventos (Dispensa, Suspensão ou Observações)', id: 'justify'},
      loaded: [
        {name: 'Eventos (Dispensa, Suspensão ou Observações)', id: 'justify'},
        {name: 'Correção de ponto', id: 'faketimelog_reason'},
        {name: 'Movimentação de posto', id: 'employee_mov'},
        {name: 'Gerenciamento de Arquivos', id: 'aprovacao_de_arquivo'}
      ]
    },
    justifyInfoRequired: false,
    fileRequired: false,
    justifyAffectsAbsence: true
  }
}

export default {
  name: 'ReasonsList',
  mounted () {
    this.isLar21 = this.$store.state.userInfo.email.includes('lar21@')
    setAmplitudeEvent('lista de motivos padrao', {})
  },
  async created () {
    await this.getData()
  },
  data () {
    return {
      carregandoSalvar: false,
      carregandoTabela: false,
      carregandoExcluir: false,
      carregandoAtivacaoDesativacao: false,
      carregandoRelatorio: false,
      isLar21: null,
      showCreateEdit: false,
      selectedReason: null,
      mode: {
        loaded: [
          {id: 'ativados', name: 'ativados'},
          {id: 'desativados', name: 'desativados'}
        ],
        selected: {id: 'ativados', name: 'ativados'}
      },
      table: {
        headerItems: [
          {column: 'nome', field: 'description', width: '0.55fr'},
          {column: 'código', field: 'code', width: '0.20fr'},
          {column: 'tipo', field: 'kind', width: '0.5fr'},
          {column: 'dados do atestado obrigatórios', field: 'justifyInfoRequired', width: '0.4fr'}
        ],
        config: {
          perPage: 10,
          startFocusedSearch: 'description',
          defaultSortField: 'description',
          defaultColumnSearch: 'description',
          detailsBox: {
            numberColumnsKeep: 1
          }
        }
      },
      saveEditInfo: defaultSaveEditInfo()
    }
  },
  computed: {
    idDaCompMan () {
      return this.$store.state.userInfo.compMan.id
    },
    totalReasons () {
      return this.$store.state.common.reasons.items.length
    },
    tableData: {
      get () {
        const loaded = this.$store.state.common.reasons.items.map(item => ({
          active: item.active,
          code: item.code,
          description: item.description,
          fileRequired: item.file_required,
          id: item.id,
          justifyInfoRequired: item.justify_info_required,
          kind: item.kind,
          justifyAffectsAbsence: item.justificativa_incide_no_absenteismo
        }))
        return {
          loading: this.carregandoTabela,
          loaded
        }
      },
      set ({selected}) {
        this.selectedReason = selected.item
      }
    },
    algoCarregando () {
      return this.carregandoTabela || this.carregandoExcluir || this.carregandoAtivacaoDesativacao
    }
  },
  methods: {
    async getData () {
      const active = this.mode.selected.id === 'ativados' ? 'true' : 'false'
      this.carregandoTabela = true
      await this.$store.dispatch('common/reasons/fetchItems', {fullReload: true, active: active})
      this.carregandoTabela = false
    },
    kindTranslator (kind) {
      return ({
        justify: 'eventos (dispensa, suspensão ou observações)',
        faketimelog_reason: 'correção de ponto',
        employee_mov: 'movimentação de posto',
        aprovacao_de_arquivo: 'gerenciamento de arquivos'
      })[kind]
    },
    async deleteReason (itemId) {
      this.carregandoExcluir = true
      try {
        await this.$API.reasons.delete({id: itemId})
        this.$modalDeSucesso('Motivo padrão removido com sucesso')
        this.$refs.table.closeDetailsBox()
        this.getData()
        this.resetNewOrEditedReason()
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível apagar esse motivo padrão')
      } finally {
        this.carregandoExcluir = false
      }
    },
    createReason () {
      this.resetNewOrEditedReason()
      this.showCreateEdit = true
    },
    async genReport () {
      this.carregandoRelatorio = true
      try {
        const result = await this.$API.reasonReport.get()
        this.$modalDeSucesso(result.data.success)
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível gerar o relatório')
      } finally {
        this.carregandoRelatorio = false
      }
    },
    changeMode () {
      this.getData()
      this.$refs.table.closeDetailsBox()
      this.$refs.table.resetPagesAndReload()
    },
    async ativarOuDesativarMotivo (itemId) {
      const active = this.mode.selected.id === 'ativados' ? 'false' : 'true'
      this.carregandoAtivacaoDesativacao = true

      try {
        await this.$API.reasons.update({id: itemId, active: active})

        this.$modalDeSucesso(`Motivo padrão  ${active === 'true' ? 'ativado' : 'desativado'} com sucesso.`)

        this.$refs.table.closeDetailsBox()
        this.getData()
        this.resetNewOrEditedReason()
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : `Não foi possível ${active === 'true' ? 'ativar' : 'desativar'} esse motivo padrão`)
      } finally {
        this.carregandoAtivacaoDesativacao = false
      }
    },
    editReason () {
      this.$refs.table.closeDetailsBox()
      this.showCreateEdit = true
      this.saveEditInfo.description = this.selectedReason.description
      this.saveEditInfo.options.selected = this.saveEditInfo.options.loaded.find(o => o.id === this.selectedReason.kind)
      this.saveEditInfo.code = this.selectedReason.code
      this.saveEditInfo.fileRequired = this.selectedReason.fileRequired
      this.saveEditInfo.justifyInfoRequired = this.selectedReason.justifyInfoRequired
      this.saveEditInfo.justifyAffectsAbsence = this.selectedReason.justifyAffectsAbsence
    },
    resetNewOrEditedReason () {
      this.showCreateEdit = false
      this.selectedReason = null
      this.saveEditInfo = defaultSaveEditInfo()
    },
    async save () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      }

      this.carregandoSalvar = true
      try {
        const params = {
          description: this.saveEditInfo.description,
          kind: this.saveEditInfo.options.selected.id,
          code: this.saveEditInfo.code,
          fileRequired: this.saveEditInfo.fileRequired,
          justifyInfoRequired: this.saveEditInfo.justifyInfoRequired,
          justifyAffectsAbsence: this.saveEditInfo.justifyAffectsAbsence
        }
        if (this.selectedReason) params.id = this.selectedReason.id

        await this.$API.reason.save(params)

        if (this.selectedReason) {
          this.$modalDeSucesso('O motivo padrão foi atualizado com sucesso.')
        } else {
          this.$modalDeSucesso('O motivo padrão foi inserido com sucesso.')
        }

        this.getData()
        this.resetNewOrEditedReason()
      } catch (e) {
        console.error(e)
        this.$modalDeErro(e?.data?.error ? e.data.error : 'Não foi possível editar/criar o motivo padrão')
      } finally {
        this.carregandoSalvar = false
      }
    }
  },
  mixins: [useValidationsMixin({deepCheck: false})]
}
</script>

<style scoped lang="scss">
.reason-list-wrapper {
  display: grid;
  grid-template-columns: 0.4fr 1fr;
  align-items: baseline;

  h2 {
    grid-column: 1/3;
    text-align: center;
  }

  .table {
    grid-column: 1/3;

    .details {
      height: 100%;
      display: grid;
      grid-row-gap: 20px;
      grid-template-rows: .5fr .5fr .5fr .5fr .5fr .5fr 1fr;

      .actions-buttons {
        display: grid;
        grid-auto-flow: column;
        grid-gap: 2px;
        grid-row: 7/7;
        justify-self: end;
        align-self: end;
      }
    }
  }
  .filters {
    grid-column: 1/3;
    display: grid;
    margin-bottom: var(--header-margin-bottom);

    .total {
      justify-self: start;
      display: grid;
      grid-template-columns: 230px 300px;
      grid-auto-flow: column;
      grid-gap: 30px;
      align-items: center;
    }

    .buttons {
      display: grid;
      grid-auto-flow: column;
      grid-column: 2/3;
      grid-gap: 1px;
      justify-self: right;
      align-self: center;
    }

  }
  .add-edit-reason {
    grid-column: 1/3;
    display: grid;
    grid-template-columns: 1fr 250px 400px 150px;
    grid-template-rows: 1fr 1fr;
    grid-column-gap: 10px;
    align-items: end;

    .tipo { grid-column: 3/5; }
    .left-checkbox {
      grid-column: 1/2;
      align-self: center;
    }
    .middle-checkbox {
      grid-column: 2/3;
      align-self: center;
    }
    .right-checkbox {
      grid-column: 3/4;
      align-self: center;
    }
    .button {
      grid-row: 2/2;
      grid-column: 4/5;
      grid-gap: 2px;
      align-self: center;
      display: grid;
      grid-auto-flow: column;
      justify-self: right;
    }
  }
}
</style>
